import en from './locales/en.json';
import es from './locales/es.json';
import pt from './locales/pt.json';
import zh from './locales/zh.json';
import fr from './locales/fr.json';
// Define the translations for each language
const translations = {
  "en": en,
  "es": es,
  "pt": pt,
  "zh": zh,
  "fr": fr
};

// i18nText component that will render the translated text
const I18nText = ({ lang, translation = "" }) => {
  // Retrieve the translation for the specified language, defaulting to 'en'
  const i18n = translations[lang] || es;
  // You can render the translated text here
  return i18n[translation]
};

export default I18nText;